import React from "react";
import EmpresasContadorTemplate from "../../components/templates/contadores/EmpresasContadorTemplate";

const EmpresasContador = () => {
    return (
        <EmpresasContadorTemplate/>
    )
}

export default EmpresasContador;